/* Marinelie — LAV IN THE AIR: die Warteliste fuers Duschoel.

   Traegt die Adresse direkt in Klaviyo ein (Client-Endpunkt, keine App).
   Die Liste steht doppelt bestaetigt — die Bestaetigungsmail kommt von
   Klaviyo, nicht von hier. */
(function () {
  if (window.mlLavBereit) return;
  window.mlLavBereit = true;

  /* Der Knopf am Duschoel klappt das Feld darunter auf. Vorher sprang er an
     einen zweiten Abschnitt am Seitenende — dort stand dasselbe Formular
     ein zweites Mal. */
  document.addEventListener('click', function (e) {
    var knopf = e.target.closest('[data-ml-lav-auf]');
    if (!knopf) return;
    var feld = document.getElementById(knopf.getAttribute('aria-controls'));
    if (!feld) return;
    var offen = feld.hidden;
    feld.hidden = !offen;
    knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
    if (offen) {
      var mail = feld.querySelector('input[type="email"]');
      if (mail) mail.focus();
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ml-lav-form]');
    if (!form) return;
    e.preventDefault();

    var stand = form.querySelector('[data-ml-lav-stand]');
    var knopf = form.querySelector('button[type="submit"]');
    var mail = (form.querySelector('input[type="email"]') || {}).value;
    var liste = form.getAttribute('data-liste');
    var firma = form.getAttribute('data-firma');

    if (!mail || !liste || !firma) {
      if (stand) stand.textContent = form.getAttribute('data-fehler') || 'Bitte E-Mail eintragen.';
      return;
    }

    if (knopf) knopf.disabled = true;
    if (stand) stand.textContent = '…';

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(firma), {
      method: 'POST',
      /* Revision 2025-07-15: die alte 2024-10-15 kennt das Feld subscriptions nicht (400), siehe ml-duelle.js. */
      headers: { 'Content-Type': 'application/json', revision: '2025-07-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'LAV in the Air — Warteliste Duschöl',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: mail,
                  /* Vormerken statt eigener Warteliste (LOG 17.10.2026); kein Produkt-Handle, solange es das Duschoel im Shop nicht gibt */
                  properties: { 'vorgemerkt_lav-duschoel': true, 'vorgemerkt_lav-duschoel_am': new Date().toISOString().slice(0, 10) },
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                },
              },
            },
          },
          relationships: { list: { data: { type: 'list', id: liste } } },
        },
      }),
    })
      .then(function (antwort) {
        if (!antwort.ok) throw new Error('klaviyo');
        if (stand) stand.textContent = form.getAttribute('data-danke') || 'Eingetragen — die Bestätigung liegt in deinem Postfach.';
        form.querySelectorAll('input, button').forEach(function (el) { el.disabled = true; });
      })
      .catch(function () {
        if (knopf) knopf.disabled = false;
        if (stand) stand.textContent = 'Das hat gerade nicht geklappt. Bitte noch einmal.';
      });
  });
})();
